import React, { useEffect, useState } from "react";
import axios from "axios";

const DistrictCommitteeManage = () => {
  const [members, setMembers] = useState([]);
  const [filteredMembers, setFilteredMembers] = useState([]);
  const [editForm, setEditForm] = useState({
    district: "",
    name: "",
    designation: "",
    image: "",
  });
  const [editId, setEditId] = useState(null);
  const [filterDistrict, setFilterDistrict] = useState("");
  const [filterDesignation, setFilterDesignation] = useState("");

  const districts = [
    "Srikakulam","Vizianagram","Visakhapatnam","Kakinada","East Godavari",
    "Konaseema","West Godavari","Eluru","Vijayawada","Krishna","Guntur",
    "Palnadu","Bapatla","Prakasam","Nellore","Nandayala","Kurnool",
    "Anantapur","SriSathyasai","Kadapa","Annamayya","TIRUPATI","CHITTOOR"
  ];
  const designations = ["President", "Secretary", "Treasurer"];

  useEffect(() => {
    fetchMembers();
  }, []);

  const fetchMembers = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`${process.env.REACT_APP_REQUESTING_API}/api/district-committee`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      setMembers(data);
      setFilteredMembers([]);
    } catch (error) {
      console.error(error);
    }
  };

  const handleEdit = (member) => {
    setEditForm(member);
    setEditId(member._id);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleImageChange = (e) => {
    const reader = new FileReader();
    reader.readAsDataURL(e.target.files[0]);
    reader.onloadend = () => setEditForm(prev => ({ ...prev, image: reader.result }));
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");
    await axios.put(
      `${process.env.REACT_APP_REQUESTING_API}/api/district-committee/${editId}`,
      editForm,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    alert("Member updated successfully!");
    setEditId(null);
    fetchMembers();
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this member?")) return;
    const token = localStorage.getItem("token");
    await axios.delete(
      `${process.env.REACT_APP_REQUESTING_API}/api/district-committee/${id}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    alert("Member deleted!");
    fetchMembers();
  };

  useEffect(() => {
    let temp = members;
    if (filterDistrict) temp = temp.filter(m => m.district === filterDistrict);
    if (filterDesignation) temp = temp.filter(m => m.designation === filterDesignation);
    setFilteredMembers(filterDistrict || filterDesignation ? temp : []);
  }, [filterDistrict, filterDesignation, members]);

  return (
    <div className="max-w-7xl mx-auto p-6">
      {/* Header */}
      <h2 className="text-3xl font-bold text-center text-gray-800 mb-2">
        District Committee Management
      </h2>
      <p className="text-center text-gray-500 mb-10">
        Filter, update or remove district committee members
      </p>

      {/* Filters */}
      <div className="flex flex-col md:flex-row justify-center gap-6 mb-10">
        <select
          value={filterDistrict}
          onChange={(e) => setFilterDistrict(e.target.value)}
          className="px-5 py-3 rounded-xl border shadow-sm"
        >
          <option value="">Filter by District</option>
          {districts.map(d => <option key={d}>{d}</option>)}
        </select>

        <select
          value={filterDesignation}
          onChange={(e) => setFilterDesignation(e.target.value)}
          className="px-5 py-3 rounded-xl border shadow-sm"
        >
          <option value="">Filter by Designation</option>
          {designations.map(d => <option key={d}>{d}</option>)}
        </select>
      </div>

      {/* Edit Form */}
      {editId && (
        <div className="bg-white border rounded-2xl shadow-lg p-6 mb-12">
          <h3 className="text-2xl font-semibold mb-6">Edit Committee Member</h3>

          <form onSubmit={handleUpdate} className="space-y-4">
            <select
              value={editForm.district}
              onChange={(e) => setEditForm({ ...editForm, district: e.target.value })}
              className="w-full px-4 py-2.5 border rounded-lg"
            >
              <option value="">Select District</option>
              {districts.map(d => <option key={d}>{d}</option>)}
            </select>

            <input
              type="text"
              value={editForm.name}
              placeholder="Member Name"
              onChange={(e) => setEditForm({ ...editForm, name: e.target.value })}
              className="w-full px-4 py-2.5 border rounded-lg"
            />

            <select
              value={editForm.designation}
              onChange={(e) => setEditForm({ ...editForm, designation: e.target.value })}
              className="w-full px-4 py-2.5 border rounded-lg"
            >
              <option value="">Select Designation</option>
              {designations.map(d => <option key={d}>{d}</option>)}
            </select>

            <input type="file" accept="image/*" onChange={handleImageChange} />

            {editForm.image && (
              <img
                src={editForm.image}
                alt="Preview"
                className="w-32 h-32 rounded-full object-cover mx-auto"
              />
            )}

            <button className="px-6 py-2.5 rounded-lg bg-green-50 text-green-700 border hover:bg-green-100">
              Update Member
            </button>
          </form>
        </div>
      )}

      {/* Cards */}
      {filteredMembers.length === 0 ? (
        <p className="text-center text-gray-500 text-lg">No Data Available</p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredMembers.map(member => (
            <div
              key={member._id}
              className="bg-white border rounded-2xl shadow hover:shadow-lg transition"
            >
              <img
                src={member.image}
                alt={member.name}
                className="w-full h-52 object-cover rounded-t-2xl"
              />
              <div className="p-5 text-center space-y-1">
                <h3 className="text-lg font-bold">{member.name}</h3>
                <p className="text-sm text-gray-700">{member.designation}</p>
                <p className="text-xs text-gray-500">{member.district}</p>

                <div className="flex justify-center gap-3 mt-4">
                  <button
                    onClick={() => handleEdit(member)}
                    className="px-4 py-1.5 rounded-lg bg-blue-50 text-blue-600 border hover:bg-blue-100"
                  >
                    Edit
                  </button>
                  <button
                    onClick={() => handleDelete(member._id)}
                    className="px-4 py-1.5 rounded-lg bg-red-50 text-red-600 border hover:bg-red-100"
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default DistrictCommitteeManage;




// working 16/12/25

// import React, { useEffect, useState } from "react";
// import axios from "axios";

// const DistrictCommitteeManage = () => {
//   const [members, setMembers] = useState([]);
//   const [filteredMembers, setFilteredMembers] = useState([]);
//   const [editForm, setEditForm] = useState({
//     district: "",
//     name: "",
//     designation: "",
//     image: "",
//   });
//   const [editId, setEditId] = useState(null);
//   const [filterDistrict, setFilterDistrict] = useState(""); 
//   const [filterDesignation, setFilterDesignation] = useState("");

//   const districts = [
//     "Srikakulam", "Vizianagram", "Visakhapatnam", "Kakinada", "East Godavari",
//     "Konaseema", "West Godavari", "Eluru", "Vijayawada", "Krishna",
//     "Guntur", "Palnadu", "Bapatla", "Prakasam", "Nellore",
//     "Nandayala", "Kurnool", "Anantapur", "SriSathyasai", "Kadapa",
//     "Annamayya", "TIRUPATI", "CHITTOOR"
//   ];
//   const designations = ["President", "Secretary", "Treasurer"];

//   useEffect(() => {
//     fetchMembers();
//   }, []);

//   const fetchMembers = async () => {
//     try {
//       const token = localStorage.getItem("token");
//       const res = await fetch(`${process.env.REACT_APP_REQUESTING_API}/api/district-committee`, {
//         method: "GET",
//         headers: {
//           "Content-Type": "application/json",
//           "Authorization": `Bearer ${token}`,
//         },
//       });
//       const data = await res.json();
//       setMembers(data);
//       setFilteredMembers([]); // 🔥 Initially empty
//     } catch (error) {
//       console.error("Error fetching members:", error);
//     }
//   };

//   const handleEdit = (member) => {
//     setEditForm({
//       district: member.district,
//       name: member.name,
//       designation: member.designation,
//       image: member.image,
//     });
//     setEditId(member._id);
//   };

//   const handleImageChange = (e) => {
//     const file = e.target.files[0];
//     const reader = new FileReader();
//     reader.readAsDataURL(file);
//     reader.onloadend = () => {
//       setEditForm((prev) => ({ ...prev, image: reader.result }));
//     };
//   };

//   const handleUpdate = async (e) => {
//     e.preventDefault();
//     if (!editId) return;

//     try {
//       const token = localStorage.getItem("token");
//       await axios.put(`${process.env.REACT_APP_REQUESTING_API}/api/district-committee/${editId}`, editForm, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });
//       alert("Member updated successfully!");
//       setEditId(null);
//       setEditForm({ district: "", name: "", designation: "", image: "" });
//       fetchMembers();
//     } catch (error) {
//       console.error("Error updating member:", error);
//       alert("Failed to update member");
//     }
//   };

//   const handleDelete = async (id) => {
//     if (!window.confirm("Are you sure you want to delete this member?")) return;

//     try {
//       const token = localStorage.getItem("token");
//       await axios.delete(`${process.env.REACT_APP_REQUESTING_API}/api/district-committee/${id}`, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });
//       alert("Member deleted successfully!");
//       fetchMembers();
//     } catch (error) {
//       console.error("Error deleting member:", error);
//       alert("Failed to delete member");
//     }
//   };

//   useEffect(() => {
//     // 🔥 Automatically filter whenever dropdowns change
//     let temp = members;
//     if (filterDistrict) {
//       temp = temp.filter(m => m.district === filterDistrict);
//     }
//     if (filterDesignation) {
//       temp = temp.filter(m => m.designation === filterDesignation);
//     }
//     if (filterDistrict || filterDesignation) {
//       setFilteredMembers(temp);
//     } else {
//       setFilteredMembers([]); // 🔥 No filter selected = show nothing
//     }
//   }, [filterDistrict, filterDesignation, members]);

//   return (
//     <div className="max-w-5xl mx-auto p-4 justify-center text-center">
//       <h2 className="text-4xl font-bold mb-12">Manage District Committee Members</h2>
//       <h2 className="text-2xl  mb-6">Please select Filters to Get Data</h2>


//       {/* 🔥 Filter Section */}
//       <div className="flex flex-col md:flex-row items-center justify-center gap-20 mb-8">
//         <select
//           value={filterDistrict}
//           onChange={(e) => setFilterDistrict(e.target.value)}
//           className="p-2 border rounded w-full md:w-1/4"
//         >
//           <option value="">Filter by District</option>
//           {districts.map((district) => (
//             <option key={district} value={district}>{district}</option>
//           ))}
//         </select>

//         <select
//           value={filterDesignation}
//           onChange={(e) => setFilterDesignation(e.target.value)}
//           className="p-2 border rounded w-full md:w-1/4"
//         >
//           <option value="">Filter by Designation</option>
//           {designations.map((designation) => (
//             <option key={designation} value={designation}>{designation}</option>
//           ))}
//         </select>
//       </div>

//       {/* Update Form */}
//       {editId && (
//         <form onSubmit={handleUpdate} className="space-y-4 mb-8 p-4 border rounded shadow">
//           <h3 className="text-xl font-semibold">Edit Member</h3>

//           <select
//             name="district"
//             value={editForm.district}
//             onChange={(e) => setEditForm({ ...editForm, district: e.target.value })}
//             className="w-full p-2 border rounded"
//           >
//             <option value="">Select District</option>
//             {districts.map((district) => (
//               <option key={district} value={district}>{district}</option>
//             ))}
//           </select>

//           <input
//             type="text"
//             name="name"
//             placeholder="Enter Name"
//             value={editForm.name}
//             onChange={(e) => setEditForm({ ...editForm, name: e.target.value })}
//             className="w-full p-2 border rounded"
//           />

//           <select
//             name="designation"
//             value={editForm.designation}
//             onChange={(e) => setEditForm({ ...editForm, designation: e.target.value })}
//             className="w-full p-2 border rounded"
//           >
//             <option value="">Select Designation</option>
//             {designations.map((designation) => (
//               <option key={designation} value={designation}>{designation}</option>
//             ))}
//           </select>

//           <input
//             type="file"
//             accept="image/*"
//             onChange={handleImageChange}
//             className="w-full p-2 border rounded"
//           />

//           {editForm.image && (
//             <img
//               src={editForm.image}
//               alt="Preview"
//               className="w-32 h-32 object-cover rounded mx-auto"
//             />
//           )}

//           <button type="submit" className="bg-green-600 text-white px-4 py-2 rounded">
//             Update Member
//           </button>
//         </form>
//       )}

//       {/* 🔥 No Data Available */}
//       {filteredMembers.length === 0 ? (
//         <p className="text-red-600 text-lg font-semibold">No Data Available</p>
//       ) : (
//         <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
//           {filteredMembers.map((member) => (
//             <div key={member._id} className="border rounded p-4 shadow">
//               <img src={member.image} alt={member.name} className="w-full h-48 object-cover rounded" />
//               <h3 className="text-lg font-bold mt-2">{member.name}</h3>
//               <p>{member.designation}</p>
//               <p className="text-sm text-gray-600">{member.district}</p>
//               <div className="flex justify-center gap-2 mt-3">
//                 <button
//                   onClick={() => handleEdit(member)}
//                   className="bg-blue-500 text-white px-3 w-20 py-1 rounded"
//                 >
//                   Edit
//                 </button>
//                 <button
//                   onClick={() => handleDelete(member._id)}
//                   className="bg-red-500 text-white px-3 w-20 py-1 rounded"
//                 >
//                   Delete
//                 </button>
//               </div>
//             </div>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// };

// export default DistrictCommitteeManage;

